export default "__VITE_ASSET__DlNGPMPq__"